<div class="parameters-display">
  @if (parameters() && parameters().length > 0) {
    <div class="overflow-x-auto">
      <table class="w-full">
        <tbody>
          @for (param of parameters(); track param.symbol; let i = $index) {
            <tr>
              <ces-parameter-display-row
                [parameter]="param"
                [index]="i"
                [types]="parameterTypes"
                [units]="units()"
                [measures]="measures()"
                [mode]="mode" />
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else if (showEmptyMessage) {
    <div class="text-(color:--text-secondary) italic p-(--padding-card)">
      {{ emptyMessage || ('forms.noParameters' | transloco) }}
    </div>
  }
</div>
